import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {HubSpotFormDefault} from './variations/DefaultVariation'
import {MultipleFormsVariation} from './variations/MultipleFormsVariation'

/**
 * Props for `HubSpotForm`.
 */
export type HubSpotFormProps = SliceComponentProps<Content.HubSpotFormSlice>

/**
 * Component for "HubSpotForm" Slices.
 */
const HubSpotForm = ({slice, index, context}: HubSpotFormProps & {context: Context}) => {
  switch (slice.variation) {
    case 'multipleForms':
      return <MultipleFormsVariation slice={slice} componentIndex={index} pageUid={context.pageUid} />

    case 'default':
      return <HubSpotFormDefault slice={slice} componentIndex={index} pageUid={context.pageUid} />

    default:
      return null
  }
}

export default HubSpotForm
